<div class="modal-header">
    <h4 class="modal-title">Push Notification</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
    <ngb-alert type="info" [dismissible]="false">
        <p class="mb-0">
            Send a push notification to the selected users mobile device. <br /><span class="small"
                >Assuming they have downloaded the Surefire Engineer App.</span
            >
        </p>
    </ngb-alert>
    <form [formGroup]="form">
        <div class="btn-group mb-3">
            <button sfButton type="button" [active]="type() === 'all'" (click)="changeType('all')">All Users</button>
            <button sfButton type="button" [active]="type() === 'users'" (click)="changeType('users')">
                Specific Users
            </button>
            <button sfButton type="button" [active]="type() === 'role'" (click)="changeType('role')">
                Group of Users
            </button>
        </div>

        <div [hidden]="type() !== 'users'" class="my-3">
            <sf-label for="user" label="Select Users"></sf-label>
            <ng-select
                id="user"
                [items]="allStaff()"
                bindLabel="fullName"
                bindValue="id"
                [multiple]="true"
                formControlName="userIds">
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    <sf-staff-select-option [staff]="item" showPicture showColour />
                </ng-template>
            </ng-select>
        </div>

        <div [hidden]="type() !== 'role'" class="my-3">
            <sf-label for="user" label="Select Role"></sf-label>
            <ng-select
                id="user"
                [items]="allRoles()"
                bindLabel="name"
                bindValue="id"
                formControlName="roleId"></ng-select>
        </div>

        <div class="row align-items-end">
            <div class="col-sm-8">
                <sf-input
                    placeholder="E.g. Please ring the office"
                    inputId="title"
                    formControlName="title"
                    label="Title"></sf-input>
            </div>
            <div class="col-sm-4">
                <sf-switch
                    inputId="highPriority"
                    formControlName="highPriority"
                    label="High Priority"
                    description="If enabled, the notification will be sent with high priority, which may result in additional alerts on the user's device."></sf-switch>
            </div>
        </div>
        <sf-input-textarea
            placeholder="The message for the user"
            formControlName="body"
            label="Message"
            [maxLength]="200"></sf-input-textarea>
    </form>
</div>
<div class="modal-footer">
    <button sfButton type="button" variant="outline" color="dark" (click)="activeModal.close('Close click')">
        Close
    </button>
    <button sfButton type="button" color="success" [disabled]="form.invalid" (click)="sendNotification()">
        {{ sendButtonText() }}
    </button>
</div>
